/**
 * OptInfra mark — OptiSigns cloud + screen + power, in blue.
 * Paths from scio3/apps/web/public/optisigns-logo-light.svg
 *
 * Both header and hero use the same artwork: blue cloud/pattern, no chip/tile
 * behind the mark — only scale and layout differ.
 */

const CLOUD_SCREEN =
  'M323.519 124.127C318.744 122.556 317.714 120.648 317.07 115.741C313.875 91.4574 301.87 75.5126 281.384 65.9625C266.054 58.8119 244.979 57.1801 228.249 63.4909L227.985 63.0831C227.387 62.1592 226.884 61.3914 226.406 60.6355C209.233 33.3048 180.104 17 148.487 17C134.988 17 121.896 19.9875 109.594 25.8903C77.9164 41.0793 59.7861 67.2942 55.7052 103.815C55.3223 107.21 54.4487 108.386 51.4569 109.49C14.8851 122.999 -5.6985 159.652 1.3861 198.633C4.56939 216.161 14.2389 232.37 28.5875 244.272C42.9601 256.185 60.8153 262.76 78.8499 262.784L148.894 263C162.082 263 172.338 252.562 172.338 239.353L172.433 210.93H114.632V175.933H114.68V117.277H255.259L255.246 210.918H197.565L197.529 239.341C197.529 252.562 208.527 262.196 221.715 262.196C221.715 262.196 276.895 262.652 291.172 262.544C301.571 262.472 312.845 260.384 323.771 256.509C352.407 246.359 370.55 220.54 369.987 190.75C369.427 160.348 350.314 132.957 323.519 124.127ZM317.667 245.963C309.087 248.603 299.742 250.055 290.646 250.187C277.947 250.367 259.841 250.462 242.49 250.475V250.426H221.451C215.36 250.426 210.394 245.448 210.394 239.341V223.912H250.676V223.996H260.632C266.017 223.996 268.53 221.488 268.53 216.089C268.53 181.428 268.53 146.767 268.53 112.106C268.53 106.37 266.172 104.031 260.38 104.031H109.642C103.849 104.031 101.492 106.37 101.492 112.106V215.861C101.492 221.572 103.921 224.008 109.618 224.008L159.509 223.936V239.353C159.509 245.472 154.542 250.439 148.451 250.439H135.18V250.414H119.515C106.41 250.414 93.3062 250.414 80.2023 250.403C46.9094 250.391 18.1282 226.767 13.2336 195.453C7.75268 160.324 26.3617 129.598 59.5466 118.992C65.0278 117.24 67.2297 114.277 67.3734 108.434C68.2828 72.7773 94.1081 40.5394 128.777 31.7931C135.251 30.1614 141.893 29.3336 148.499 29.3336C177.065 29.3336 203.788 44.9785 218.232 70.1736C220.051 73.3291 221.918 76.6044 226.082 76.6044C227.411 76.6044 228.859 76.2685 230.522 75.5605C237.272 72.7171 244.261 71.2774 251.298 71.2774C275.841 71.2774 301.932 92.7294 304.766 114.685C306.418 127.45 310.69 132.813 322.346 136.737C343.516 143.875 358.81 168.531 357.913 194.073C357.064 217.973 340.897 238.837 317.667 245.963Z';

const POWER_RING =
  'M214.325 150.93C211.464 145.123 207.132 140.516 201.424 137.24C200.658 136.797 199.808 136.568 198.959 136.568C196.673 136.568 194.746 138.14 194.28 140.396C193.825 142.603 194.734 144.403 197.068 145.891C205.852 151.494 209.837 161.248 207.444 171.338C205.014 181.572 195.56 188.986 184.969 188.986C183.725 188.986 182.468 188.878 181.235 188.674C173.624 187.403 167.365 182.663 164.062 175.669C160.747 168.662 161.059 160.792 164.912 154.073C166.851 150.678 169.687 147.846 173.588 145.411C175.838 144.007 176.484 141.116 175.072 138.848C174.187 137.408 172.619 136.52 170.991 136.52C170.082 136.52 169.196 136.797 168.431 137.324L168 137.624C165.786 139.16 163.488 140.744 161.597 142.699C153.914 150.654 150.886 160.132 152.61 170.882C155.183 186.935 168.371 198.584 184 198.584H184.179C192.126 198.584 198.528 196.581 204.356 192.274C212.757 186.059 217.292 177.456 217.855 166.671C218.094 161.512 216.909 156.197 214.325 150.93Z';

const POWER_STEM =
  'M179.943 149.316C179.931 151.859 179.919 154.403 179.967 156.934C180.014 159.862 182.264 162.237 184.969 162.237H184.981C187.674 162.225 189.971 159.85 189.995 157.042C190.055 149.544 190.055 142.213 189.995 135.29C189.971 132.459 187.721 130.143 184.969 130.143C182.228 130.143 180.027 132.411 179.979 135.302C179.931 137.822 179.943 140.377 179.955 142.849C179.955 143.725 179.967 144.589 179.967 145.464V146.064C179.955 147.144 179.943 148.236 179.943 149.316Z';

/** Mark viewBox from OptiSigns lockup (cloud+screen+power only). */
const MARK_VB = '0 17 370 246';

function CloudScreenPower({ color }: { color: string }) {
  return (
    <g fill={color}>
      <path d={CLOUD_SCREEN} />
      <path d={POWER_RING} />
      <path d={POWER_STEM} />
    </g>
  );
}

function Mark({
  color,
  width,
  height,
}: {
  color: string;
  width: number;
  height: number;
}) {
  return (
    <svg
      className="brand-mark"
      width={width}
      height={height}
      viewBox={MARK_VB}
      fill="none"
      aria-hidden="true"
    >
      <CloudScreenPower color={color} />
    </svg>
  );
}

export function Logo({
  size,
  wordmark = true,
  variant = 'header',
}: {
  size?: number;
  wordmark?: boolean;
  variant?: 'header' | 'hero';
}) {
  const isHero = variant === 'hero';
  // Header mark ~half hero height so the top bar stays compact but prominent.
  const markH = size ?? (isHero ? 72 : 40);
  const markW = Math.round(markH * (370 / 246));

  return (
    <span className={`brand brand--${variant}`}>
      <Mark color="var(--blue-500)" width={markW} height={markH} />
      {wordmark && <span className="brand-word">OptInfra</span>}
    </span>
  );
}
